// ---------------------------------------------------------------------------
// Dados do escritório — fonte única de verdade.
//
// REGRA: nada aqui pode ser inventado. Endereço, nome, OAB e canais de
// atendimento aparecem no site, nos dados estruturados e no Google. Declarar
// um endereço comercial que não existe derruba a verificação do Google Meu
// Negócio e compromete o domínio inteiro.
// ---------------------------------------------------------------------------

export const site = {
  // Nome civil completo — usado em títulos, rodapé e no schema Person.
  nome: 'Felipe Gomes de Almeida',
  // Forma curta, para mensagens de WhatsApp e espaços estreitos.
  nomeCurto: 'Felipe Almeida',
  cargo: 'Advogado Criminalista',

  // Registro profissional — obrigatório em toda comunicação (Provimento 205/2021 CFOAB)
  oab: 'OAB/DF 82.152',

  telefone: '(61) 98104-3547',
  telefoneLink: '+5561981043547',
  celular: '(61) 98104-3547',
  whatsapp: '5561981043547',
  email: 'felipealmeida@advdf.com.br',

  // Não há endereço comercial aberto ao público: só a praça de atuação.
  // Se um dia houver escritório próprio, acrescente aqui logradouro e CEP
  // e reative o PostalAddress em src/seo.js.
  endereco: {
    cidade: 'Brasília',
    uf: 'DF',
  },

  atuacao: {
    base: 'Brasília/DF',
    alcance: 'Todo o Brasil',
    presencial:
      'Atendimento presencial no Distrito Federal, sempre com hora marcada',
    remoto: 'Reuniões por videoconferência para clientes de qualquer estado',
  },

  horario: 'Segunda a sexta, das 9h às 18h',
  plantao: 'Plantão 24 horas para prisões em flagrante e casos urgentes',

  instagram: 'https://instagram.com/adv.felipealmeida_',
  linkedin: 'https://www.linkedin.com/in/felipealmeida2002/',

  url: 'https://www.felipealmeida.adv.br',
};

/** Praça de atuação, para uso em textos corridos. */
export const praca = `${site.endereco.cidade}/${site.endereco.uf}`;

/** Iniciais usadas no logotipo — derivadas do nome, ignorando "de", "da", "dos"... */
export const monograma = site.nome
  .split(/\s+/)
  .filter((parte) => parte.length > 2 && !/^(de|da|do|das|dos)$/i.test(parte))
  .map((parte) => parte[0])
  .filter((_, indice, todas) => indice === 0 || indice === todas.length - 1)
  .join('')
  .toUpperCase();

/**
 * Monta um link do WhatsApp com mensagem pré-preenchida.
 * @param {string} texto mensagem inicial enviada pelo cliente
 */
export function linkWhatsApp(
  texto = `Olá, gostaria de falar com o *Dr. ${site.nomeCurto}.*`
) {
  return `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(texto)}`;
}
